import { createClient } from '@/shared/api';
import type { UploadPdfReportMutation, UploadPdfReportMutationVariables } from '@/shared/api';
import UPLOAD_PDF_REPORT_MUTATION from '../mutations/uploadPdfReport';

/**
 * Uploads a PDF report file to the backend. Runs the uploadPdfReport mutation and throws the returned message when it does not report success.
 *
 * @param input - Mutation input carrying the PDF and its report metadata.
 * @returns A promise resolving once the PDF has been uploaded.
 */
const handleUploadPdfReport = async (
  input: UploadPdfReportMutationVariables['input'],
): Promise<void> => {
  const client = createClient();
  const uploadPdfReportResult = await client.mutate<
    UploadPdfReportMutation,
    UploadPdfReportMutationVariables
  >({
    mutation: UPLOAD_PDF_REPORT_MUTATION,
    variables: {
      input,
    },
  });
  const { data } = uploadPdfReportResult;
  // API always returns this field for a resolved mutation; code already accessed it unconditionally.
  const { uploadPdfReport } = data!;
  if (!uploadPdfReport.isSuccess) {
    throw new Error(uploadPdfReport.message ?? undefined);
  }
};

export default handleUploadPdfReport;
